export const renameFundHouseBasedOnFundHouseId = (fundhouseId) => {
  switch (fundhouseId) {
    case 'RELIANCE':
      return 'Nippon India';

    default:
      return fundhouseId;
  }
};

export const renameFundHouseBasedOnAmcNameInsightPage = (amcName) => {
  switch (amcName) {
    case 'RELIANCE':
      return 'NIPPON';
    case 'IDFC':
      return 'BANDHAN';
    case 'YES':
      return 'WHITEOAK';
    case 'IIFL':
      return '360 ONE';
    case 'RELIGARE':
      return 'INVESCO';
    case 'LNT':
      return 'HSBC';

    default:
      return amcName;
  }
};
